// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelFormBody-Start_cls1__AGPuC","cls2":"PaymentChannelFormBody-Start_cls2__YaGNG PaymentChannelFormBody-Start_cls1__AGPuC"};